<template>
    <div
        class="relative flex justify-center items-center h-full"
        v-if="loading"
    >
        <div
            class="w-12 h-12 p-1 bg-white rounded-full shadow flex justify-center items-center"
            :class="{'w-12 h-12': size === 'large', 'w-8 h-8': size === 'medium', 'w-5 h-5': size === 'small'}"
            role="status"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                height="600"
                width="600"
                x="0"
                y="0"
                viewBox="0 0 600 600"
                class="map-spinner"
            >
                <defs>
                    <linearGradient
                        id="Gradient1"
                        gradientTransform="rotate(90)"
                    >
                        <stop offset="0%" stop-color="rgba(255, 84, 0, 1)" />
                        <stop
                            offset="100%"
                            stop-color="rgba(255, 84, 0, 0.5)"
                        />
                    </linearGradient>
                    <linearGradient
                        id="Gradient2"
                        gradientTransform="rotate(90)"
                    >
                        <stop
                            offset="0%"
                            stop-color="rgba(246, 246, 246, 0)"
                            stop-opacity="0"
                        />
                        <stop offset="90%" stop-color="rgba(255, 84, 0, 0.5)" />
                    </linearGradient>
                </defs>
                <circle
                    cx="300"
                    cy="300"
                    r="280"
                    stroke="url(#Gradient1)"
                    stroke-width="40"
                    fill="none"
                />
                <circle
                    cx="300"
                    cy="300"
                    r="260"
                    stroke="url(#Gradient2)"
                    stroke-width="40"
                    fill="none"
                />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'large'
        }
    }
};
</script>

<style scoped>
.map-spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
